<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>
      
      <div class="deposit-location-query-workspace">
        <aside v-if="showContextPanel" class="deposit-location-query-context-panel">
          <b-card no-body class="deposit-location-query-tree-card">
            <div class="deposit-location-query-panel-heading">
              <span><AppIcon name="account_tree" /> Ubicaciones</span>
              <b-button variant="link" class="deposit-location-query-panel-toggle" @click="showContextPanel = false" v-b-tooltip.hover title="Ocultar ubicaciones">
                <AppIcon name="chevron-left" />
              </b-button>
            </div>
            <div class="deposit-location-query-selector deposit-location-query-selector--panel">
              <div class="deposit-location-query-selector__form">
                <FindObject render="search"
                            type="deposits"
                            @select-object="loadDepositsSelect($event)"
                            :valueID="filters.deposits_id"
                            :showAllRegister="true"/>
                <div class="deposit-location-query-selector__context">
                  <AppIcon name="info" />
                  <span>Seleccioná un depósito.</span>
                </div>
              </div>
            </div>
            <div v-if="!treeLoader" class="deposit-location-query-tree-body">
              <vue-tree-list
                @click="selectedItem"              
                :model="depositsTree"
                v-bind:default-expanded="true"              
                v-if="deposits && deposits.length"
                class="deposit-query-tree-custom"
              >                      
                <template v-slot:leafNameDisplay="slotProps">                
                  <span>
                    &nbsp;&nbsp;{{ slotProps.model.name }}
                  </span>
                </template>              

                <span class="icon" slot="treeNodeIcon"><AppIcon name="warehouse" />&nbsp;</span>
                <span class="icon" slot="leafNodeIcon"><AppIcon name="location_on" />&nbsp;</span>
              </vue-tree-list>  
              <EmptyState v-else icon="warehouse" title="No hay ubicaciones" description="Consultá un depósito para cargar sus ubicaciones." />
            </div>
            <div class="tree-deposit-query deposit-location-query-tree-body" v-else>
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </b-card>         
        </aside>

        <div v-else class="deposit-location-query-context-collapsed" @click="showContextPanel = true" v-b-tooltip.hover.right title="Mostrar ubicaciones">
          <AppIcon name="chevron-right" />
          <span>Ubicaciones</span>
        </div>

        <main v-if="deposits && deposits.length" class="deposit-location-query-results" :class="{ 'deposit-location-query-results--expanded': !showContextPanel }">
          <b-card class="deposit-location-query-results-card">
            <b-row>
              <b-col md="7" class="mb-2 mb-md-0">
                <b-form-radio-group v-model="filters.typeQuery" 
                                    :options="optTypeQuery" 
                                    @input="setTypeQuery(treeSelectItem)"
                                    class="deposit-location-query__view-modes">
                </b-form-radio-group>            
              </b-col>
              <b-col md="5">              
                <div class="deposit-location-query__switches">
                  <b-form-checkbox  v-model="filters.viewUnitSale"  
                                    switch 
                                    size="sm"
                                    @input="saveViewUnitStorage()">
                    Ver en unidad de venta
                  </b-form-checkbox>   
                  <b-form-checkbox  v-model="filters.showWithoutStock"  
                                    switch 
                                    size="sm" 
                                    @input="setTypeQuery(treeSelectItem)"
                                    v-if="filters.typeQuery == 'group'">
                    Mostrar Productos Sin Stock
                  </b-form-checkbox>   
                </div>
              </b-col>              
              <b-col md="12" class="mt-1">            
                <b-table class="app-table mb-0"
                        stacked="md"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        :busy="table.isBusy"   
                        v-if="table.items.length || table.isBusy">

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>
                  
                    <template v-slot:cell(date)="data">
                      <div v-if="data.item.operation">
                        {{moment(data.item.operation.date).format('DD/MM/YYYY')}}
                      </div>
                    </template>   

                    <template v-slot:cell(productCode)="data">
                      <div v-html="getDetailCode(data.item)"></div>
                    </template>     

                    <template v-slot:cell(productName)="data">
                      <div v-html="getDetailName(data.item)"></div>
                    </template>                

                    <template v-slot:cell(operation)="data">                                 
                      <div v-if="data.item.operation.type">
                        {{data.item.operation.type.name}} #{{data.item.operation.number}}                        
                      </div>
                    </template>

                    <template v-slot:cell(quantity)="data">     
                      <span v-if="filters.typeQuery == 'mov'">                            
                        {{data.item.type_balance}} {{formatQuantity(getDisplayQuantity(data.item))}}
                      </span>
                      <span v-else>                            
                        {{formatQuantity(getDisplayQuantity(data.item))}}
                      </span>                  
                      <span v-if="getDisplayUnitReference(data.item)">{{getDisplayUnitReference(data.item)}}</span>
                    </template>

                    <template v-slot:cell(location)="data">
                      <DepositLocationLabel :location="data.item.location" />
                    </template>                

                </b-table>
                <EmptyState v-else icon="inventory_2" title="Sin existencias para mostrar" description="Elegí un depósito y una ubicación para consultar el stock." />
              </b-col>
              <b-col md="12" v-if="table.items.length && !table.isBusy">
                <div class="deposit-location-stock-total">
                  <b-row>
                    <b-col md="10">
                      <div class="deposit-location-stock-total__title">Total de stock</div>
                    </b-col>
                    <b-col md="2" class="text-right">
                      <span v-html="getStockTotal()"></span>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </main>
      </div>
      

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav v-if="table.tablePaginate">
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.tablePaginate.total"
                            :per-page="table.tablePaginate.per_page"
                            v-model="table.currentPage" 
                            @input="filterReport()" />
            </nav>
          </b-col>          
        </b-row>
      </b-card>
  
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Funciones from '@/handler/funciones' 
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject' 
  import Storage from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  import Vue from 'vue'
  import { VueTreeList, Tree } from 'vue-tree-list'
  Vue.use(VueTreeList)  

  export default {
    components: {
      FindObject,
      VueTreeList,
      TabHeaderActions,
    },    
    data: () => {
      return {      
        access: {
          module_id: Modules.DEPOSITOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudDepositsQueryByLocations',
          elements: {}
        }, 
        deposits: null,
        depositsTree: new Tree([]),
        table : {
          items: [],
          fields: [],
          isBusy: false,
          currentPage: 1,
          perPage: 0,
          tablePaginate: null,          
        },     
        filters: {
          deposits: null,
          deposits_id: 0, 
          location_id: 0,
          type: 'deposits',
          typeQuery: 'group',
          showWithoutStock: false,
          viewUnitSale: false,
        },              
        treeLoader: false,
        treeSelectItem: null,
        showContextPanel: true,
        keyForceUpdate: 0,     
        optTypeQuery: [
          { text: 'Agrupado por Productos', value: 'group'},
          { text: 'Movimiento de Entrada y Salida', value: 'mov'},
        ]                         
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
      this.restoreViewUnitStorage()
    },  
    mounted() {
      this.loadFieldTable()
    },    
    methods: {
      loadFieldTable() {
        this.table.fields = []

        if(this.filters.typeQuery=='mov') {
          this.table.fields.push({key: 'date', label: 'Fecha', class: 'align-middle'})
          this.table.fields.push({key: 'operation', label: 'Operación', class: 'align-middle'})
        }

        this.table.fields.push({key: 'location', label: 'Ubicación', sortable: true, class: 'align-middle'}) 
        this.table.fields.push({key: 'productCode', label: 'Código', class: 'align-middle'})
        this.table.fields.push({key: 'productName', label: 'Producto', class: 'align-middle'})
        this.table.fields.push({key: 'quantity', label: 'Cantidad', class: 'align-middle text-right'})        
      },      
      getRowCount (items) {
        return items.length
      },

      forceUpdate() {
        this.keyForceUpdate = this.keyForceUpdate + 1
      },

      loadDepositsSelect (object) {        
        if(object){
          this.filters.deposits = object
          this.filters.deposits_id = object.id     
          
          this.filters.type = 'deposits'
          
          this.filterReport()
        } else {
          this.filters.deposits = null
          this.filters.deposits_id = 0
        }
      },

      loadDeposits() {                
        var result = serviceAPI.filtrarActivityGroupDeposit(this.filters)
        
        result.then((response) => {          
          this.treeLoader = false
          
          this.deposits = [];  
          this.depositsTree = new Tree(this.deposits);  

          var data = response.data
          if(data.length) {
            var arrDeposits = []
            data.forEach(element => {                         
              var deposit_id = 0
              var deposit_name = 'SIN DEPOSITO'
              if(element.location.zone.deposit) {
                deposit_id = element.location.zone.deposit.id
                deposit_name = element.location.zone.deposit.name + ' (' + element.location.zone.deposit.reference + ')'
              }

              arrDeposits.push({
                id: deposit_id,
                name: deposit_name,
                zone_id: element.location.zone_id,
                zone: {
                  id: element.location.id,
                  name: element.location.zone.reference + ' | ' + element.location.reference,                  
                }
              })
            });
                          
            arrDeposits = Funciones.sortArrayInteger(arrDeposits,'zone_id','asc')              
            
            var groupDeposit = []            
            arrDeposits.forEach(element => {
              if(groupDeposit[element.id] == undefined) {
                groupDeposit[element.id] = [] 
                groupDeposit[element.id].id = element.id
                groupDeposit[element.id].name = element.name
                groupDeposit[element.id].children = []
              }
            });            
            groupDeposit = groupDeposit.filter(Boolean)
            
            this.configTree(groupDeposit, arrDeposits)
          }           
        })
        .catch(error => {                  
          this.treeLoader = false
          this.$awn.alert(Error.showError(error))
        });    
      },      

      configTree(group, data) { 
        this.deposits = []             

        group.forEach((element, index) => {                                                                    
          this.deposits.push({            
            id: element.id,                  
            name: element.name,            
            dragDisabled: true,
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,                     
            children: [],
          })

          this.getChildren(this.deposits[index], data)
        })                  

        this.depositsTree = new Tree(this.deposits)
      },
      getChildren(obj, data) {     
        if(data) {        
          data.forEach(element => {        
            if(obj.id == element.id) {
              var existe = false
              obj.children.forEach(item => {
                if(item.id == element.zone.id) {
                  existe = true
                }
              });

              if(!existe) {
                obj.children.push({
                  id: element.zone.id,      
                  name: element.zone.name,                
                  dragDisabled: true,
                  addTreeNodeDisabled: true,
                  addLeafNodeDisabled: true,
                  editNodeDisabled: true,
                  delNodeDisabled: true,                  
                  isLeaf: true,                            
                })    
              }                                  
            }  
          });     
        }   
      },
      selectedItem(params) {         
        if(params.isLeaf) {          
          this.filterReport(params.id, false)
          this.treeSelectItem = params
        } else {
          this.filterReport(null, false)
          this.treeSelectItem = null          
        }            
      },

      setTypeQuery(params) {
        if(this.filters.typeQuery != 'group') {
          this.filters.showWithoutStock = false
        }

        if(params) {
          this.filterReport(params.id, false)    
        } else {
          this.filterReport(null, false)    
        }
      },

      filterReport(location_id, loadDeposits = true) {              
        if(!this.filters.deposits_id) {
          this.$awn.alert("No se seleccionó el depósito.")
          this.deposits = null
          this.table.items = []
          return false
        }

        this.filters.location_id = location_id

        if(loadDeposits) { 
          this.deposits = null
          this.treeLoader = true
        }

        this.table.isBusy = true        
        var result = serviceAPI.filtrarActivity(this.filters, this.table.currentPage)

        result.then((response) => {          
          var data = response.data.data          
          this.table.items = data          
          this.table.isBusy = false

          this.table.tablePaginate = response.data
          
          this.loadFieldTable()

          if(loadDeposits) {
            this.loadDeposits()
          }          
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });                
      },

      getStockTotal() {
        var total = 0
        if(this.table.items.length) {
          this.table.items.forEach(element => {
            var qty = this.getDisplayQuantity(element)
            if(element.type_balance) {
              if(element.type_balance == '+') {
                total = total + Math.abs(parseFloat(qty))
              } else {
                total = total - Math.abs(parseFloat(qty))
              }
            } else {
              total = total + parseFloat(qty)
            }
          });
          var unitRef = this.getDisplayUnitReference(this.table.items[0])
          if(parseFloat(total)<0) {
            total = '<span class="text-danger">' + this.formatQuantity(total) + " " + unitRef + "</span>"
          } else {
            total = '<span class="text-success">' + this.formatQuantity(total) + " " + unitRef + "</span>"
          }                   
        }
        return total
      },
      getDisplayQuantity(item) {
        if(this.filters.viewUnitSale && item && item.quantity_sale !== undefined && item.quantity_sale !== null) {
          return item.quantity_sale
        }
        return item ? item.quantity : 0
      },
      getDisplayUnitReference(item) {
        if(this.filters.viewUnitSale && item && item.unit_measurement_sale_reference) {
          return item.unit_measurement_sale_reference
        }
        if(item && item.unit_measurement) {
          return item.unit_measurement.reference
        }
        return ''
      },
      formatQuantity(value) {
        const num = parseFloat(value)
        if (Number.isNaN(num)) {
          return (0).toFixed(4)
        }
        return num.toFixed(4)
      },
      saveViewUnitStorage() {
        Storage.setValue('deposits_query_locations_view_unit_sale', this.filters.viewUnitSale)
      },
      restoreViewUnitStorage() {
        if(Storage.getValue('deposits_query_locations_view_unit_sale') !== null) {
          this.filters.viewUnitSale = Storage.getValue('deposits_query_locations_view_unit_sale') == 'true'
        }
      },

      // PRODUCTOS
      getDetailCode(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductCode(item)
        }            
        if(item.products_compound_id) {          
          return item.products_compound.code
        }                
      },
      getDetailName(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductName(item)
        }               
        if(item.products_compound_id) {          
          return item.products_compound.name
        }                
      },       
      getProductCode(item) {
        if(item.products_id) {
          return item.product.code
        }

        if(item.products_colors_id) {
          const prod = item.products_color
          return prod.code
        }

        if(item.products_waist_id) {
          const prod = item.products_waist
          return prod.code
        }

        if(item.products_color_waist_id) {
          const prod = item.products_color_waist
          return prod.code
        }
      },      
      getProductName(item) {
        if(item.products_id) {
          return item.product.name
        }

        if(item.products_colors_id) {
          const prod = item.products_color
          return prod.name + ' (' + prod.color.name + ')'
        }

        if(item.products_waist_id) {
          const prod = item.products_waist
          return prod.name + ' (' + prod.waist.name + ')'
        }

        if(item.products_color_waist_id) {
          const prod = item.products_color_waist
          return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
        }
      },      
    }    
  }
</script>

<style>
  .deposit-location-query-selector {
    border-color: var(--app-color-border);
    background: var(--app-color-surface);
    box-shadow: var(--app-shadow-sm);
  }
  .deposit-location-query-selector--panel {
    border-bottom: 1px solid var(--app-color-border);
    box-shadow: none;
  }
  .deposit-location-query-selector__context {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 1px 0;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    line-height: 1.2;
  }
  .deposit-location-query-selector__context .app-icon {
    color: var(--app-color-icon);
    font-size: 11px;
  }
  .deposit-location-query-panel-heading .app-icon {
    color: var(--app-color-primary);
  }
  .deposit-location-query-selector__form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    margin: 0;
    padding: 9px 14px 10px;
  }
  .deposit-location-query-selector__form .form-group {
    width: 100%;
  }
  .deposit-location-query-selector .form-group {
    margin-bottom: 0;
  }
  .deposit-location-query-selector label {
    display: block;
    margin-bottom: 4px;
    font-size: var(--app-text-xs);
    text-align: left;
  }
  .deposit-location-query-workspace {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  .deposit-location-query-context-panel {
    flex: 0 0 320px;
    max-width: 320px;
    margin-top: 8px;
  }
  .deposit-location-query-results {
    flex: 1;
    min-width: 0;
    margin-top: 8px;
  }
  .deposit-location-query-results--expanded {
    width: calc(100% - 46px);
  }
  .deposit-location-query-tree-card {
    overflow: hidden;
  }
  .deposit-location-query-panel-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0;
    padding: 12px 14px;
    border-bottom: 1px solid var(--app-color-border);
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
  }
  .deposit-location-query-panel-heading span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .deposit-location-query-panel-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 27px;
    height: 27px;
    padding: 0;
    color: var(--app-color-icon);
  }
  .deposit-location-query-tree-body {
    max-height: 68vh;
    overflow: auto;
    padding: 8px;
  }
  .deposit-location-query-context-collapsed {
    display: flex;
    flex: 0 0 34px;
    min-height: 260px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 4px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-primary);
    cursor: pointer;
    writing-mode: vertical-rl;
  }
  .tree-deposit-query {
    padding: 28px 0;
    text-align: center;
  }
  .deposit-query-tree-custom .icon:hover {
    cursor: pointer;
  }
  .deposit-query-tree-custom .vtl-node-content:hover {
    cursor: pointer;
  }   
  .deposit-location-stock-total {
    margin-top: 16px;
    padding: 10px 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 9px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text);
  }
  .deposit-location-stock-total span {
    display: block;
    text-align: right;
    font-size: var(--app-text-md);
    font-weight: var(--app-font-semibold);
  }  
  .deposit-location-stock-total__title {
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .deposit-location-query__view-modes .custom-control {
    margin-right: 14px;
  }
  .deposit-location-query__switches {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  @media (min-width: 1200px) {
    .deposit-location-query__switches {
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      gap: 16px;
    }
    .deposit-location-query__switches .custom-control-label {
      white-space: nowrap;
    }
  }
  @media (max-width: 767.98px) {
    .deposit-location-query-selector__form {
      padding: 9px 12px 10px;
    }
    .deposit-location-query__view-modes .custom-control {
      display: block;
      margin: 0 0 8px;
    }
    .deposit-location-query-workspace {
      flex-direction: column;
    }
    .deposit-location-query-context-panel,
    .deposit-location-query-results,
    .deposit-location-query-results--expanded {
      width: 100%;
      max-width: none;
      flex-basis: auto;
    }
    .deposit-location-query-context-collapsed {
      width: 100%;
      min-height: 34px;
      flex-basis: auto;
      margin-top: 8px;
      writing-mode: horizontal-tb;
    }
    .deposit-location-stock-total,
    .deposit-location-stock-total span {
      text-align: left;
    }
    .deposit-location-stock-total span {
      display: inline-block;
      margin-top: 4px;
    }
  }
</style>
